import * as React from 'react';

// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
export const SafeReact = { ...React } as typeof React;
